import React from "react";

interface SpamDetectionCardProps {
  title?: string;
  flaggedBy?: string;
  knownAlias?: string;
  modusOperandi?: string;
  lastSeen?: string;
  reportedOn?: string;
  reportId?: string;
  className?: string;
}

const SpamDetectionCard: React.FC<SpamDetectionCardProps> = ({
  title = "FraudDetect • Spam",
  flaggedBy,
  knownAlias,
  modusOperandi,
  lastSeen,
  reportedOn,
  reportId,
  className = "",
}) => {
  return (
    <div
      className={`bg-white rounded-lg border border-gray-200 p-6 shadow-sm ${className}`}
    >
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>

      <div className="space-y-4">
        {flaggedBy && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Flagged By
            </label>
            <p className="text-gray-600">{flaggedBy}</p>
          </div>
        )}

        {knownAlias && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Known Alias
            </label>
            <p className="text-gray-900">{knownAlias}</p>
          </div>
        )}

        {modusOperandi && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Modus Operandi (MO)
            </label>
            <p className="text-gray-900">{modusOperandi}</p>
          </div>
        )}

        {lastSeen && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Last Seen
            </label>
            <p className="text-gray-900">{lastSeen}</p>
          </div>
        )}

        {reportedOn && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Reported On
            </label>
            <p className="text-gray-900">{reportedOn}</p>
          </div>
        )}

        {reportId && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Report ID
            </label>
            <p className="text-gray-600">{reportId}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SpamDetectionCard;
